import GalleryCarouselConnect, {
  GalleryCarouselConnectProps
} from './GalleryCarouselConnect'

export { GalleryCarouselConnect }
export type { GalleryCarouselConnectProps }
